import React from "react";
import { Box, Typography } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { useUser } from "../../pages/login/UserContextPersistent";

const PUBLIC_AUTH_PATHS = new Set([
  "/",
  "/login",
  "/otp-verify",
  "/auth-phone",
  "/register",
  "/registerConfirm",
  "/registermore",
  "/registerfeature",
  "/registerneedinfo",
  "/driver/register",
]);

const isPublicAuthPath = (pathname = "") => {
  if (PUBLIC_AUTH_PATHS.has(pathname)) {
    return true;
  }

  return ["/register", "/driver/register"].some((path) =>
    pathname.startsWith(`${path}/`),
  );
};

export default function OrganizationInactiveBanner() {
  const { state, organizationInactive } = useUser();
  const { t } = useTranslation();
  const { pathname } = useLocation();

  if (
    !organizationInactive ||
    !state?.isAuthenticated ||
    isPublicAuthPath(pathname)
  ) {
    return null;
  }

  return (
    <Box
      role="status"
      className="organization-inactive-banner"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "10px",
        padding: "12px 24px",
        backgroundColor: "#FDE7E7",
        borderBottom: "1px solid #EE3B2B",
        color: "#D32F2F",
        textAlign: "center",
      }}
    >
      <ErrorOutlineIcon sx={{ fontSize: 22 }} />
      <Typography
        sx={{
          fontFamily: "Roboto",
          fontWeight: 600,
          fontSize: { xs: "14px", md: "16px" },
        }}
      >
        {t(
          "Your organization is inactive. You have view-only access — please contact the RouteEye admin to activate it.",
        )}
      </Typography>
    </Box>
  );
}
